import { Menu } from "lucide-react";

export default function Header({ sidebarOpen, toggleSidebar, logo }) {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center justify-between px-4 md:px-6 py-3">
        <div className="flex items-center gap-4">
          <button 
            onClick={toggleSidebar}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
          >
            <Menu size={24} />
          </button>
          <div className="md:hidden">
            <img src={logo} alt="Indomie" className="h-9 object-contain" />
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="hidden md:block">
            <h1 className="text-lg font-semibold text-gray-900">Survey Admin</h1>
          </div>
        </div>
      </div>
    </header>
  );
}